export const mockUsers = [
  {
    username: "domainKing",
    displayName: "Kevin Chen",
    avatar: "https://i.pravatar.cc/150?img=12",
    bio: "Professional domain trader. Love finding the next big brand. DM for trades.",
    memberSince: "2024-01-01",
    location: "San Francisco, CA",
    badges: ["topTrader", "speedDemon", "eliteMember"],
    stats: {
      totalDomains: 47,
      totalSales: 89,
      totalVolume: 324890,
      winRate: 94,
      avgFlipTime: 12,
      roi: 287
    },
    rating: 4.8,
    reviewCount: 124,
    followers: 2341,
    following: 156,
    tier: "elite"
  },
  {
    username: "cryptoQueen",
    displayName: "Sarah Martinez",
    avatar: "https://i.pravatar.cc/150?img=5",
    bio: "Crypto domain specialist. Building the future, one domain at a time.",
    memberSince: "2024-01-05",
    location: "Austin, TX",
    badges: ["topTrader", "cryptoExpert"],
    stats: {
      totalDomains: 34,
      totalSales: 56,
      totalVolume: 187340,
      winRate: 88,
      avgFlipTime: 18,
      roi: 156
    },
    rating: 4.6,
    reviewCount: 78,
    followers: 1456,
    following: 89,
    tier: "pro"
  },
  {
    username: "startupGuru",
    displayName: "Mike Johnson",
    avatar: "https://i.pravatar.cc/150?img=8",
    bio: "Helping startups find their perfect domain. 10+ years experience.",
    memberSince: "2024-01-03",
    location: "New York, NY",
    badges: ["topTrader", "helper"],
    stats: {
      totalDomains: 28,
      totalSales: 67,
      totalVolume: 234560,
      winRate: 92,
      avgFlipTime: 15,
      roi: 198
    },
    rating: 4.9,
    reviewCount: 102,
    followers: 1823,
    following: 134,
    tier: "pro"
  },
  {
    username: "techPro",
    displayName: "Alex Wong",
    avatar: "https://i.pravatar.cc/150?img=15",
    bio: "Tech domain investor. Always looking for the next unicorn.",
    memberSince: "2024-01-08",
    location: "Seattle, WA",
    badges: ["topTrader"],
    stats: {
      totalDomains: 23,
      totalSales: 41,
      totalVolume: 145230,
      winRate: 85,
      avgFlipTime: 21,
      roi: 134
    },
    rating: 4.7,
    reviewCount: 56,
    followers: 987,
    following: 67,
    tier: "pro"
  },
  {
    username: "dataScientist",
    displayName: "Emily Rivera",
    avatar: "https://i.pravatar.cc/150?img=9",
    bio: "Data-driven domain investing. AI & analytics focus.",
    memberSince: "2024-01-12",
    location: "Boston, MA",
    badges: ["risingStart"],
    stats: {
      totalDomains: 15,
      totalSales: 23,
      totalVolume: 67890,
      winRate: 78,
      avgFlipTime: 25,
      roi: 89
    },
    rating: 4.5,
    reviewCount: 34,
    followers: 456,
    following: 98,
    tier: "free"
  },
  {
    username: "healthTechPro",
    displayName: "David Kim",
    avatar: "https://i.pravatar.cc/150?img=13",
    bio: "Health tech domains. Passionate about healthcare innovation.",
    memberSince: "2024-01-10",
    location: "Los Angeles, CA",
    badges: [],
    stats: {
      totalDomains: 12,
      totalSales: 18,
      totalVolume: 45600,
      winRate: 72,
      avgFlipTime: 30,
      roi: 67
    },
    rating: 4.4,
    reviewCount: 23,
    followers: 234,
    following: 45,
    tier: "free"
  },
  {
    username: "buyer123",
    displayName: "James Wilson",
    avatar: "https://i.pravatar.cc/150?img=3",
    bio: "Looking for great domains for my projects.",
    memberSince: "2024-01-14",
    location: "Chicago, IL",
    badges: [],
    stats: {
      totalDomains: 8,
      totalSales: 3,
      totalVolume: 12400,
      winRate: 50,
      avgFlipTime: 45,
      roi: 23
    },
    rating: 4.2,
    reviewCount: 8,
    followers: 89,
    following: 156,
    tier: "free"
  },
  {
    username: "trader456",
    displayName: "Lisa Chen",
    avatar: "https://i.pravatar.cc/150?img=7",
    bio: "Active trader, love the thrill of the flip!",
    memberSince: "2024-01-11",
    location: "Miami, FL",
    badges: ["speedDemon"],
    stats: {
      totalDomains: 19,
      totalSales: 34,
      totalVolume: 89560,
      winRate: 81,
      avgFlipTime: 14,
      roi: 112
    },
    rating: 4.6,
    reviewCount: 45,
    followers: 567,
    following: 234,
    tier: "pro"
  },
  {
    username: "aiEnthusiast",
    displayName: "Robert Taylor",
    avatar: "https://i.pravatar.cc/150?img=11",
    bio: "AI domains are the future. Collecting the best.",
    memberSince: "2024-01-06",
    location: "San Diego, CA",
    badges: [],
    stats: {
      totalDomains: 16,
      totalSales: 21,
      totalVolume: 78900,
      winRate: 75,
      avgFlipTime: 22,
      roi: 95
    },
    rating: 4.5,
    reviewCount: 29,
    followers: 345,
    following: 123,
    tier: "free"
  },
  {
    username: "techInvestor",
    displayName: "Maria Garcia",
    avatar: "https://i.pravatar.cc/150?img=6",
    bio: "Tech investor. Portfolio diversification through domains.",
    memberSince: "2024-01-09",
    location: "Denver, CO",
    badges: ["portfolioKing"],
    stats: {
      totalDomains: 52,
      totalSales: 45,
      totalVolume: 198760,
      winRate: 86,
      avgFlipTime: 28,
      roi: 145
    },
    rating: 4.7,
    reviewCount: 67,
    followers: 1234,
    following: 89,
    tier: "elite"
  },
  {
    username: "mlExpert",
    displayName: "Chris Anderson",
    avatar: "https://i.pravatar.cc/150?img=14",
    bio: "Machine learning & AI domain collector.",
    memberSince: "2024-01-07",
    location: "Portland, OR",
    badges: [],
    stats: {
      totalDomains: 11,
      totalSales: 15,
      totalVolume: 34200,
      winRate: 68,
      avgFlipTime: 35,
      roi: 54
    },
    rating: 4.3,
    reviewCount: 18,
    followers: 198,
    following: 76,
    tier: "free"
  },
];

export default mockUsers;
